import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { lifecycle, compose, withHandlers, withState } from 'recompose'
import SalesforceMapping, { MappingType } from './component'
import { getSalesforceToggles } from 'app/modules/integrations/api'
import { orgId as getOrgId } from 'app/modules/org/selectors'

import { CustomerAPI, json } from '@driftt/dapper'

const mapStateToProps = (state) => ({
  orgId: getOrgId(state)
})

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({}, dispatch),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),

  withState('selectedTab', 'selectTab', () => {
    return MappingType.LEAD
  }),
  withState('hasCaseCutover', 'setHasCaseCutover', false),
  withState('hasContactCreationSynced', 'setContactCreationSynced', false),
  withHandlers({
    onTabClick: ({ selectTab }) => tab => {
      selectTab(tab)
    },
    receiveToggles: ({ setContactCreationSynced }) => resp => {
      setContactCreationSynced(resp.hasContactCreationSynced || false)
    }
  }),
  lifecycle(
    {
      componentDidMount() {
        document.getElementsByClassName('app-content-container')[0].scrollTo(0,0)
        getSalesforceToggles()
          .then(this.props.receiveToggles)
          .catch(err => console.warn(err))

        CustomerAPI.get(`/cutover/organizations/${this.props.orgId}?namespace=ORG_HAS_SALESFORCE_TICKETING`)
          .then(json)
          .then(({ ORG_HAS_SALESFORCE_TICKETING }) => {
            this.props.setHasCaseCutover(ORG_HAS_SALESFORCE_TICKETING)
          })
      }
    }
  )
)(SalesforceMapping)



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/SalesforceMapping/index.js